import React from 'react';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import { makeStyles, Theme, Typography, TypographyProps } from '@material-ui/core';

import { Message } from 'common/interfaces/common';

import commonMessages from 'common/messages/messages';

const useStyles = makeStyles((theme: Theme) => ({
  status: {
    '&.isActive': {
      color: theme.palette.success.main,
    },
    '&.isOutlined': {
      color: 'white',
      height: 20,
      borderRadius: 3,
      padding: '2px 4px',
      backgroundColor: theme.palette.error.main,
      fontWeight: 700,
      fontSize: 12,
      lineHeight: '16px',

      '&.isActive': {
        backgroundColor: theme.palette.success.main,
      },
    },
  },
}));

interface IProps extends TypographyProps {
  isActive: boolean;
  isOutlined?: boolean;
  activeOptionMessage?: Message;
  inactiveOptionMessage?: Message;
  inactiveOptionColor?: 'textSecondary' | 'error';
}

const StatusLabel = ({
  isActive,
  isOutlined = false,
  activeOptionMessage,
  inactiveOptionMessage,
  inactiveOptionColor = 'textSecondary',
  className,
  children,
  ...other
}: IProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Typography
      variant="body1"
      color={isActive ? 'initial' : inactiveOptionColor}
      className={cx(classes.status, { isActive }, { isOutlined }, className)}
      component="span"
      {...other}
    >
      {children || (
        <FormattedMessage
          {...(isActive
            ? activeOptionMessage || commonMessages.activeOption
            : inactiveOptionMessage || commonMessages.inactiveOption)}
        />
      )}
    </Typography>
  );
};

export default StatusLabel;
